export default "__VITE_ASSET__BJoH9V_N__"